import React from 'react';
import { motion } from 'framer-motion';
const days = [{
  icon: '🧠',
  title: 'Día 1 y 2: El Interruptor Biológico',
  description: 'La Maniobra del Nervio Vago — una respiración de 4-8 segundos que le ordena a tu sistema nervioso que se apague. Sin meditación. Sin apps.'
}, {
  icon: '🆘',
  title: 'Día 3: Protocolo SOS para Crisis',
  description: 'El Método Grounding 5-4-3-2-1 para cortar una crisis de ansiedad en menos de 2 minutos — donde estés, cuando la necesites.'
}, {
  icon: '🌙',
  title: 'Día 4: El Cierre de Pestañas Mentales',
  description: 'La técnica Brain Dump nocturna para vaciar tu mente antes de dormir y dejar de repasar todo lo que no hiciste.'
}, {
  icon: '☀️',
  title: 'Día 5 y 6: Blindaje Diario',
  description: 'Micro-pausas de Descompresión para que el estrés no se acumule durante el día y no explote de noche.'
}, {
  icon: '⚡',
  title: 'Día 7: El Hack Químico',
  description: 'Cómo resetear tu dopamina con nutrición y movimiento para salir del modo supervivencia para siempre.'
}];
export function ProgramBreakdown() {
  return <section className="py-16 md:py-24 px-4 bg-base" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main" data-id="element-83">
            Esto es exactamente lo que vas a recibir:
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-84">
          {days.map((day, i) => <motion.div key={day.title} initial={{
          opacity: 0,
          y: 25
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-card/60 border border-warm/15 rounded-2xl p-6 md:p-8 flex flex-col" data-id="element-85">
              <span className="text-4xl mb-4 block" data-id="element-86">{day.icon}</span>
              <h3 className="text-lg font-bold text-main mb-3 leading-snug" data-id="element-87">
                {day.title}
              </h3>
              <p className="text-sm text-muted leading-relaxed" data-id="element-88">
                {day.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}